import { CameraScanComponentModule } from './camera-scan/CameraScanRouting.module';

/* eslint-disable max-len */
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MallGuard } from './mall/services/guard/mall.guard';
import { EmptyComponentComponent } from './empty-component/empty-component.component';

export const externalUrlProvider = {
  provide: 'externalUrlRedirectResolver',
  useValue: (route: any) => {
    window.location.href = route.data.externalUrl;
  },
};

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'dashboard',
  //   pathMatch: 'full',
  // },
  {
    path: '',
    redirectTo: 'newdashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardPageModule),
  },
  {
    path: 'newdashboard',
    loadChildren: () =>
      import('./newdashboard/newdashboard.module').then((m) => m.NewdashboardPageModule),
  },
  {
    path: 'scan',
    loadChildren: () =>
      import('./camera/Camera.module').then((m) => m.CameraModule),
  },
  {
    path: 'result/:code',
    loadChildren: () =>
      import('./camera-scan/CameraScanRouting.module').then(
        (m) => m.CameraScanComponentModule
      ),
  },
  {
    path: 'catalog',
    loadChildren: () =>
      import('./digital-services/catalog/catalog.module').then(
        (m) => m.CatalogPageModule
      ),
  },
  {
    path: ':name/digital-service',
    loadChildren: () =>
      import('./digital-services/digital-service/digital-service.module').then(
        (m) => m.DigitalServicePageModule
      ),
  },
  {
    path: 'coming-soon',
    loadChildren: () =>
      import('./mall/coming-soon/coming-soon.module').then(
        (m) => m.ComingSoonPageModule
      ),
  },
  {
    path: 'verification',
    loadChildren: () =>
      import('./verification-services/home/home.module').then(
        (m) => m.HomePageModule
      ),
  },
  {
    path: 'verification/pvs-service',
    loadChildren: () =>
      import('./verification-services/pvs-service/pvs-service.module').then(
        (m) => m.PvsServicePageModule
      ),
  },
  {
    path: 'verification/bundle-service',
    loadChildren: () =>
      import(
        './verification-services/bundle-service/bundle-service.module'
      ).then((m) => m.BundleServicePageModule),
  },
  {
    path: 'mall',
    component: EmptyComponentComponent,
    data: { isMallRoute: true }
  },
  //  {
  //   path: 'mall',
  //   loadChildren: () =>
  //     import('./mall/mall.module').then((m) => m.MallModule),
  //   canLoad: [MallGuard],
  // },
  //   {
  //   path: 'mall',
  //   component: class {}, // Dummy component to satisfy Angular
  //   data: {
  //     externalUrl: 'https://mall.payarena.com/'
  //   },
  //   canActivate: [MallGuard]
  // },
  {
    path: 'products',
    loadChildren: () =>
      import('./mall/products/products.module').then(
        (m) => m.ProductsPageModule
      ),
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('./mall/orders/orders.module').then((m) => m.OrdersPageModule),
  },
  {
    path: 'terms-conditions',
    loadChildren: () =>
      import('./terms-conditions/terms-conditions.module').then(
        (m) => m.TermsConditionsPageModule
      ),
  },
  {
    path: 'create-wallet/:token',
    loadChildren: () =>
      import('./wallet/create-wallet/create-wallet.module').then(
        (m) => m.CreateWalletPageModule
      ),
  },
  {
    path: 'fund-wallet',
    loadChildren: () =>
      import('./wallet/fund-wallet/fund-wallet.module').then(
        (m) => m.FundWalletPageModule
      ),
  },
  {
    path: 'fund-transfer',
    loadChildren: () =>
      import('./wallet/fund-transfer/fund-transfer.module').then(
        (m) => m.FundTransferPageModule
      ),
  },
  {
    path: 'newwallet',
    loadChildren: () => import('./newwallet/newwallet.module').then( m => m.NewwalletPageModule)
  },
  {
    path: 'transactionpage',
    loadChildren: () => import('./transactionpage/transactionpage.module').then( m => m.TransactionpagePageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
